import { typeDataToArray } from "./_typeDataToArray.js";
export const toObject = async (source, selector) => {
    const dataFunc = source.dataFunc;
    const values = await typeDataToArray(dataFunc);
    const map = {};
    for (const value of values) {
        map[selector(value)] = value;
    }
    return map;
};
